import { SkeletonBlock } from "./SkeletonBlock";

export function PageSkeleton() {
  return (
    <div className="min-h-screen bg-paper p-6">
      <div className="max-w-6xl mx-auto space-y-5">
        <SkeletonBlock className="h-8 rounded w-1/3" />
        <SkeletonBlock className="h-4 rounded w-1/2" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <SkeletonBlock key={i} className="h-36 rounded-lg" />
          ))}
        </div>
      </div>
    </div>
  );
}